import "./select2"

;(function($) {
  "use strict"
  $(function() {
    $(".js-select").select2()
  })
})(jQuery)
